module.exports = __webpack_public_path__ + "img/following-step03.57a429be.svg";